import React, { useEffect, useState } from 'react'
import styles from '../ModulosEdosCuenta/edosCuenta.module.sass'
import { Header } from 'pages/Header'

import { Footer } from 'pages/Footer'
import { MenuCredito } from 'components/menuCredito'
import { Error500 } from 'components/Error/Error500'
import { EmptyMonths, ListMonths, ResultPerMonth } from '../ModulosEdosCuenta'


export function EstadoCuentaList(props){
    const {
        errorCode,
        acountStatusData,
        respMovements,
        dataTransaction,
        setRango,
        date
    } = props

    // console.log('respMovements: ', respMovements)

    const [perMonth, setPerMonth] = useState()
    const [index, setIndex] = useState()

    const resetMonth = () => {
        setPerMonth()
    }

    useEffect(()=>{},[perMonth])

    return(
        <>
            <Header type="complete" />
            <main>
                <section className="sectionPrincipal">
                    <MenuCredito />
                    {errorCode >= 500
                        ? <Error500 />
                        : <div className={styles?.contentSection}>
                            <h1 onClick={resetMonth} className={styles?.h1Title}>Estado de Cuenta</h1>
                            <div className={styles?.contListMonths}>
                                {perMonth
                                    ?
                                        <ResultPerMonth
                                            perMonth={perMonth}
                                            respMovements={respMovements}
                                            dataTransaction={dataTransaction}
                                            setRango={setRango}
                                            index={index}
                                        />
                                    :
                                        acountStatusData?.fechas?.length > 0
                                            ?
                                                <ListMonths
                                                    meses={acountStatusData?.fechas} 
                                                    setRango={setPerMonth}
                                                    setIndex={setIndex}
                                                />
                                            : <EmptyMonths date={date} />
                                }
                            </div>
                        </div>
                    }
                </section>
            </main>
            <Footer type="complete" />
        </>
    )
}